/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {


    export interface IFieldScope extends angular.IScope {
        field: Wars.Domain.Model.Field;
        formData: any;
        formDataChange: any;
        processId: string;
        isReadonly: boolean;
        isEditMode: boolean;
        formDataId: string;
        formId: string;
        tinyMceOptions: any;
        formSectionUniqueId: string;
        rowId: string;
        parentFormId: string;
        hasUpdated: boolean;
        processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        processConfigurationId: string;
        stepId: string;
        process: Wars.Domain.Model.Dtos.ProcessDto;
        states: Wars.Domain.Model.Dtos.FlatStatusAndStateDto[];
        processStates: Wars.Domain.Model.Dtos.FlatStatusAndStateDto[];
        processTypes: Wars.Domain.Model.Dtos.ProcessTypeDto[];
        subTypes: Wars.Domain.Model.Dtos.ProcessSubTypeDto[];
        statuses: Wars.Domain.Model.Dtos.FlatStatusAndStateDto[];
        dropdownOptions: models.CodeDropDownItem[];
        documentTypeOptions: models.CodeDropDownItem[];
        autoCompleteValue: string;
        calculationValue: any;
        claimGroups: Wars.Domain.Model.Dtos.ClaimGroupDto[],
        reviewGroups: Wars.Domain.Model.Dtos.ReviewGroupDto[],
        documentUpdated(model: models.FileUploadModel);
        hideSection: any;
        metaDataReadOnly: boolean;
    }

    export class Field implements IDirective {
        public constructor(private upload: any,
            private $timeout: angular.ITimeoutService,
            private formDataService: services.FormDataService) {

        }

        public link($scope: IFieldScope,
            element: JQuery,
            attrs: ng.IAttributes) {
        }

        public templateUrl = "./app/views/directives/inputForm/field.html";
        public restrict: string = "E";
        public controller = [
            "$scope", "Upload", "$timeout", "formDataService", "signalrService", "userService",
            "manageScheduledResourcesService", "growl", "$q", "formCodeFunctionService", "customDivService",
            "applicationCodeService", "ngAuthSettings", 'autoCompleteService', 'processService', 'apiGridService',
            'processTypeService', 'processSubTypeService', "configurationCacheService", 'ModalService', '$location',
            '$rootScope', 'conditionService','gisMapService', FieldController
        ];
        public controllerAs = "controller";
        public scope: any = {
            field: "=",
            formData: "=",
            formDataChange: "=",
            processId: "=",
            isReadonly: "=",
            isEditMode: "=",
            formDataId: "=",
            formId: "=", 
            formSectionUniqueId: "=",
            rowId: "=",
            parentFormId: "=",
            process: "=",
            processConfiguration: "=",
            processConfigurationId: "=",
            stepId: "="
        };
    }

    export class FieldController {
        constructor(
            private $scope,
            private upload: any,
            private $timeout: angular.ITimeoutService,
            private formDataService: services.FormDataService,
            signalRService: services.ISignalrService,
            userService: services.UserService,
            manageScheduledResourceService: services.ManageScheduledResourcesService,
            private growl: angular.growl.IGrowlService,
            $q: angular.IQService,
            formCodeFunctionService: services.FormCodeFunctionService,
            customDivService: services.CustomDivService,
            applicationCodeService: services.ApplicationCodeService,
            ngAuthSettings: any,
            autoCompleteService: services.AutoCompleteService,
            private processService: services.ProcessService,
            apiGridService: services.ApiGridService,
            processTypeService: services.ProcessTypeService,
            subTypeService: services.ProcessSubTypeService,
            configurationCacheService: Services.ConfigurationCacheService,
            modalService: any,
            $location: angular.ILocationService,
            private $rootScope: angular.IRootScopeService,
            conditionService: services.ConditionService,
            gisMapService:services.GisMapService)
        {
            $scope.metaDataReadOnly = false;

            $scope.model = new FieldModel(
                $scope,
                formDataService,
                $timeout,
                upload,
                signalRService,
                userService,
                manageScheduledResourceService,
                growl,
                $q,
                formCodeFunctionService,
                customDivService,
                applicationCodeService,
                ngAuthSettings,
                autoCompleteService,
                processService,
                apiGridService,
                processTypeService,
                subTypeService,
                configurationCacheService,
                modalService,
                $location,
                $rootScope,
                conditionService,
                gisMapService);

            $scope.documentUpdated = (model: models.FileUploadModel) => $scope.model.documentUpdated(model);
            $scope.hideSection = { hideSection: false };
        }
    }

    export class FieldModel {
        private customFunction: Wars.Domain.Model.Dtos.CustomFunctionDto;

        field: Wars.Domain.Model.Field;
        formData: any;
        formDataChange: any;
        processId: string;
        isReadonly: boolean;
        isEditMode: boolean;
        formDataId: string;
        formId: string;
        localTimeZone: string;
        selectedState: Wars.Domain.Model.Dtos.FlatStatusAndStateDto;
        radioButtonOptions: Wars.Domain.Model.Codes.SystemCode[];
        currentValue: any;

        public acceptsText: string = ".gif,.jpeg,.jpg,.jpe,.tiff,.tif,.pdf,.doc,.docx,.xls,.xlsx,.txt,.dwg";

        tinyMceOptions: any = {
            //format: 'raw',
            menubar: false,
            inline: true,
            plugins: "autolink anchor link code",
            content_css: "content/mce.css",
            toolbar1:
                'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | code',
            setup(editor) {
            }
        };

        marker: any = {};
        map: any = {
            center: { latitude: 28.4158, longitude: -81.2989 },
            zoom: 6,
            events: {
                click(map, eventName, args) {
                    this.marker.coordinates = {
                        latitude: args[0].latLng.lat(),
                        longitude: args[0].latLng.lng()
                    }
                    if (this.$scope.formData) {
                        this.$scope.formData[this.$scope.field.schemaProperty
                            .uniqueIdentifier] = this.$scope.marker.coordinates;
                        this.fieldChanged();
                    }
                    this.$scope.$apply();

                    if (this.$scope.formDataChange) {
                        this.$scope.formDataChange();
                    }
                }
            }
        };
        progress: number;
        pattern: string;
        step: string;
        errorMsg: string;

        constructor(
            private $scope: IFieldScope,
            private formDataService: services.FormDataService,
            private $timeout: angular.ITimeoutService,
            private upload: any,
            private signalRService: services.ISignalrService,
            private userService: services.UserService,
            private manageScheduledResourceService: services.ManageScheduledResourcesService,
            private growl: angular.growl.IGrowlService,
            private $q: angular.IQService,
            private formCodeFunctionService: services.FormCodeFunctionService,
            private customDivService: services.CustomDivService,
            private applicationCodeService: services.ApplicationCodeService,
            private ngAuthSettings: any,
            private autoCompleteService: services.AutoCompleteService,
            private processService: services.ProcessService,
            private apiGridService: services.ApiGridService,
            private processTypeService: services.ProcessTypeService,
            private subTypeService: services.ProcessSubTypeService,
            private configurationCacheService: services.ConfigurationCacheService,
            private modalService: any,
            private $location: angular.ILocationService,
            private $rootScope: angular.IRootScopeService,
            private conditionService: services.ConditionService,
            private gisMapService:services.GisMapService) {


            if ($scope.process && $scope.process.metadata &&
                $scope.process.metadata[$scope.field.schemaProperty.uniqueIdentifier]) {
                const metadataObj = JSON.parse($scope.process.metadata[$scope.field.schemaProperty.uniqueIdentifier]);

                if (metadataObj.isReadonly) {
                    this.$scope.metaDataReadOnly =true;
                }
            }

            $scope.$watch('rowId',
                () => {
                    this.setListMetadata();
                });

            // Striping out Standard or Daylight because times do not have a date context and therefore are neither standard or daylight time.
            this.localTimeZone = warsApp.DateTimeHelper.GetTimeZoneNameWithoutDaylightOrStandard();

            if ($scope.field.maxTextLength == null ||
                $scope.field.maxTextLength === 0 ||
                $scope.field.maxTextLength > 4000) {
                $scope.field.maxTextLength = 4000;
            }

            if ($scope.field.textAreaRows == null || $scope.field.textAreaRows < 5 || $scope.field.textAreaRows > 20) {
                $scope.field.textAreaRows = 5;
            }

            if (($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.Percentage ||
                    $scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.Number) &&
                $scope.field.decimalPlaces > 0) {
                this.pattern = "/^[0-9]+(\.[0-9]{1," + $scope.field.decimalPlaces + "})?$/";
                this.step = "0.01";
            }

            //USER PICKER ********************************************************************
            //all this to decode the user picker value and display the user's name
            var decodeUserDelegate = (model) => {
                if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.UserSelector) {
                    if (!$scope.formData) {
                        return;
                    };
                    var warsUserId = $scope.formData[$scope.field.schemaProperty.uniqueIdentifier];
                    if (warsUserId == null) {
                        model.selectedUser = null;
                    } else {
                        userService.getUser(warsUserId)
                            .then((result) => {
                                model.selectedUser = result;
                            });
                    }
                }
            }

            if (this.$scope.formData) {
                this.currentValue = this.$scope.formData[this.$scope.field.schemaProperty.uniqueIdentifier];
            }

            var cb = undefined;

            if ($scope.field != undefined && $scope.field.type != undefined) {
                if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.PhoneNumber ||
                    $scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.Zipcode ||
                    ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.TextBox &&
                    $scope.field.mask != undefined &&
                    $scope.field.mask != null &&
                    $scope.field.mask !== "")) {
                    $scope.$on('onBeforeUnload',
                        (e) => {
                            this.fieldChanged();
                        });
                }
            }

            decodeUserDelegate(this);
            //listen for the broadcast from form clear to remove the user bound to the picker
            cb = $rootScope.$on('userPickerCleared',
                (event, data) => {
                    if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.UserSelector) {
                        (<any>this).selectedUser = null;
                    }
                });
            //destroy the listener on scope destroy to avoid memory leak
            $scope.$on("$destroy",
                () => {
                    if (cb != undefined) {
                        cb();    
                    }
                });
            //END USER PICKER ********************************************************************


            if ($scope.field.condition_id && $scope.field.clearOnDisplayConditionHide) {
                $scope.$watchCollection('process.conditionStates',
                    () => {
                        if ($scope.process &&
                            $scope.process.conditionStates &&
                            !$scope.process.conditionStates[$scope.field.condition_id] &&
                            $scope.formData[$scope.field.schemaProperty.uniqueIdentifier]) {
                            $scope.formData[$scope.field.schemaProperty.uniqueIdentifier] = null;
                            if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.UserSelector) {
                                (<any>this).selectedUser = null;
                            }
                            this.fieldChanged();
                        }
                    });
            }

            if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.Location) {
                if ($scope.formData) {
                    var watchField = 'formData["' + $scope.field.schemaProperty.uniqueIdentifier + '"]';
                    var appWatch = $scope.$watch(watchField,
                        newVal => {
                            if (newVal) {
                                this.marker.coordinates = $scope.formData[$scope.field.schemaProperty.uniqueIdentifier];
                                this.fieldChanged();
                                appWatch();
                            }
                        });
                }
            }

            if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.CustomButton) {
                if (this.$scope.process) {
                    const stepFunctions: Wars.Domain.Model.Dtos.CustomFunctionDto[] = $scope.process.customStepFunctions
                        [this.$scope.stepId];
                    if (stepFunctions) {
                        this.customFunction = Enumerable.from(stepFunctions)
                            .singleOrDefault(s => s.fieldId === $scope.field.id);
                    }
                }
            }

            if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.ProcessType) {
                this.processTypeService.getExecutionProcessTypes()
                    .then(types => {
                        if ($scope.field.fieldExcludedProcessTypes != null && types != null) {
                            var excludes = [];
                            for (var x = 0; x < types.length; x++) {
                                for (var i = 0; i < $scope.field.fieldExcludedProcessTypes.length; i++) {
                                    if ($scope.field.fieldExcludedProcessTypes[i].processType_id === types[x].id) {
                                        excludes.push(types[x]);
                                    }
                                }
                            }
                            $scope.processTypes = Enumerable.from(types).except(excludes).distinct(t => t.id).toArray();
                        } else {
                            $scope.processTypes = types;
                        }
                    });
            }

            if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.SubType) {
                this.subTypeService.getExecutionProcessSubTypes()
                    .then(types => {
                        $scope.subTypes = types;
                    });
            }

            if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.AutoComplete && this.$scope.formData) {
                let processId = this.$scope.formData[this.$scope.field.schemaProperty.uniqueIdentifier];
                if (processId) {
                    if (this.$scope.process.processNames[processId]) {
                        $scope.autoCompleteValue = this.$scope.process.processNames[processId];
                    } else {
                        this.processService.getProcessName(processId)
                            .then(name => {
                                $scope.autoCompleteValue = name;
                                this.$scope.process.processNames[processId] = name;
                                //console.log(this.$scope.process.processNames);
                            });
                    }
                }
            }

            if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.ClaimGroup) {
                this.configurationCacheService.getSystemClaimGroups().then(claimGroups => {
                    this.$scope.claimGroups = claimGroups;
                });
            }

            if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.Map) {
                if (this.$scope.process) {
                    $scope.$on('mapLoaded',()=>this.gisMapService.addFeaturesLayer(this.$scope.process.features, true));
                }
            }

            if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.ReviewGroup) {
                this.configurationCacheService.getSystemReviewGroups().then(reviewGroups => {
                    this.$scope.reviewGroups = reviewGroups;
                });
            }

            if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.Dropdown) {
                this.reloadDropdownCodes();
            }

            if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.RadioButton) {
                this.reloadRadioButtonOptions();
            }

            if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.MultiSelectStatus ||
                $scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.Status)
            {
                this.configurationCacheService.getSystemStatuses().then(
                    (statuses: Wars.Domain.Model.Dtos.FlatStatusAndStateDto[]) => {
                        this.$scope.statuses = [];
                        statuses.forEach(flatDto => {
                            if ($scope.field.fieldExcludedStatuses == null ||
                                $scope.field.fieldExcludedStatuses.length === 0 ||
                                !Enumerable.from($scope.field.fieldExcludedStatuses).any(f => f.statusCode.uniqueIdentifier === flatDto.statusCodeUniqueId))
                            {
                                this.$scope.statuses.push(flatDto);
                            }
                        });
                    });
            }

            if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.MultiSelectState ||
                $scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.State) {

                this.configurationCacheService.getSystemStates().then(
                    (states: Wars.Domain.Model.Dtos.FlatStatusAndStateDto[]) => {
                        this.$scope.states = [];
                        states.forEach(flatDto => {
                            if ($scope.field.fieldExcludedStates == null ||
                                $scope.field.fieldExcludedStates.length === 0 ||
                                !Enumerable.from($scope.field.fieldExcludedStates).any(f => f.stateCode.uniqueIdentifier === flatDto.stateCodeUniqueId))
                            {
                                this.$scope.states.push(flatDto);
                            }
                        });
                    });
            }

            if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.StateChange) {
                this.configurationCacheService.getProcessStates(this.$scope.processConfigurationId).then(
                    (states: Wars.Domain.Model.Dtos.FlatStatusAndStateDto[]) => {
                        this.$scope.processStates = states;
                    });
            }

            if ($scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.ScheduledResource) {
                this.reloadScheduledResourceCodes();
                if ($scope.formData && !$scope.formData[$scope.field.schemaProperty.uniqueIdentifier]) {
                    $scope.formData[$scope.field.schemaProperty.uniqueIdentifier] = {};
                }
            }

            var self = this;

            if (self.$scope.processId) {
                this.signalRService.broadcast($scope)
                    .then((broadcaster) => {
                        broadcaster.enterProcess(self.$scope.processId, false);
                    });

                let currentUser = this.userService.getCurrentUser();
                this.signalRService.listen($scope)
                    .then((listener) => {
                        listener.onSignalGroupOfProcessDataUpdate((user, result) => {
                            if (result.type !== "FieldUpdate" || currentUser.userName === user)
                                return;

                            for (var i = 0; i < result.updatedFields.length; i++) {
                                var updatedField: Wars.Domain.Model.Dtos.UpdatedFieldValueDto = result.updatedFields[i];
                                if (updatedField.fieldUniqueId === self.$scope.field.schemaProperty.uniqueIdentifier) {
                                    self.$scope.hasUpdated = false;
                                    $scope.$apply(() => {
                                    });
                                    self.$scope.hasUpdated = true;
                                }
                            }
                        });
                    });
            }
        }

        private reloadDropdownCodes(): void {
            if (!this.$scope.field.schemaProperty.codeGroup_id)
                return;

            const excludes = Enumerable.from(this.$scope.field.fieldExcludedSystemCodes)
                .select(c => c.systemCode.uniqueIdentifier).toArray();

            const context = <any>{ removeSpecifiedOptions: excludes };

            if (this.$scope.processId) {
                this.applicationCodeService.getProcessLevelApplicationCodesForExecution(
                    this.$scope.field.schemaProperty.codeGroup_id,
                    this.$scope.processConfigurationId,
                    false).then(
                    (applicationCodes) => {
                        this.$scope.dropdownOptions = this.applicationCodeService
                            .buildCodeDropDownOptions(applicationCodes, true, context);
                    });
            } else {
                this.applicationCodeService.getApplicationCodesForConfiguration(
                    this.$scope.field.schemaProperty.codeGroup_id,
                    false).then((applicationCodes) => {
                    this.$scope.dropdownOptions = this.applicationCodeService
                        .buildCodeDropDownOptions(applicationCodes, true, context);
                });
            }
        }

        private reloadRadioButtonOptions(): void {
            if (!this.$scope.field.schemaProperty.codeGroup_id)
                return;

            const excludes = Enumerable.from(this.$scope.field.fieldExcludedSystemCodes).select(c => c.systemCode.uniqueIdentifier).toArray();
            this.radioButtonOptions = Enumerable.from(this.$scope.field.schemaProperty.codeGroup.codes)
                                                .where(i => excludes.indexOf(i.uniqueIdentifier) === -1)
                                                .orderBy(i => i.uniqueIdentifier)
                                                .toArray();
        }

        private reloadScheduledResourceCodes(): void {
            if (!this.$scope.field.schemaProperty.scheduledResourceConfiguration ||
                !this.$scope.field.schemaProperty.scheduledResourceConfiguration.parentCodeGroup_id)
                return;

            if (this.$scope.processId) {
                this.applicationCodeService.getProcessLevelApplicationCodesForExecution(
                    this.$scope.field.schemaProperty.scheduledResourceConfiguration.parentCodeGroup_id,
                    this.$scope.processConfigurationId,
                    false).then(
                    (applicationCodes) => {
                        this.$scope.dropdownOptions = this.applicationCodeService
                            .buildCodeDropDownOptions(applicationCodes, true);
                    });
            } else {
                this.applicationCodeService.getApplicationCodesForConfiguration(
                    this.$scope.field.schemaProperty.scheduledResourceConfiguration.parentCodeGroup_id,
                    false).then((applicationCodes) => {
                    this.$scope.dropdownOptions = this.applicationCodeService
                        .buildCodeDropDownOptions(applicationCodes, true);
                });
            }
        }

        public deleteDocument(uniqueIdentifier: string): void {
            alert("In-Work");
        }

        public showHistory() {
            this.modalService.showModal({
                    templateUrl: "./app/views/modals/historyModal.html",
                    controller: "historyModalController",
                    size: 'lg',
                    inputs: {
                        process: this.$scope.process,
                        processConfigId: this.$scope.processConfigurationId,
                        uniqueId: this.$scope.field.schemaProperty.parentObjectSchema.isList
                            ? this.$scope.field.schemaProperty.parentObjectSchema.uniqueIdentifier
                            : this.$scope.field.schemaProperty.uniqueIdentifier,
                        formDataId: this.$scope.formDataId,
                        propertyId: this.$scope.field.schemaProperty.parentObjectSchema.isList
                            ? this.$scope.field.schemaProperty.uniqueIdentifier
                            : undefined,
                        codeGroupId: this.$scope.field.schemaProperty.codeGroup_id,
                        rowId: this.$scope.rowId

                    }
                })
                .then(modal => {
                    modal.element.modal();
                    modal.close.then(result => {
                        $('.modal-backdrop')
                            .each(function() {
                                $(this).remove();
                            });
                    });
                });
        }

        public runCustomFunction() {
            if (this.customFunction) {
                if (this.$scope.rowId) {
                    let args = ['processId', 'formId', 'formDataId', 'rowId', this.customFunction.javascript];
                    let myFunc = Function.apply(null, args);

                    myFunc(this.$scope.processId, this.$scope.formId, this.$scope.formDataId, this.$scope.rowId);
                } else {
                    let args = ['processId', 'formId', 'formDataId', this.customFunction.javascript];
                    let myFunc = Function.apply(null, args);

                    myFunc(this.$scope.processId, this.$scope.formId, this.$scope.formDataId);
                }
            }
        }


        public runPostSaveEvents() {
            if (!this.$scope.process) {
                return;
            }

            if (this.$scope.field.processAction_id) {
                this.processService.runProcessAction(this.$scope.process.id, this.$scope.field.processAction_id)
                    .then((process) => {
                        (process as any).isFieldChangedProcessAction = true;
                        this.$rootScope.$broadcast('ProcessChanged', process);
                    });
            }
        }

        public calculate() {
            this.formDataService.calculate(this.$scope.processId, this.$scope.field.calculation_id)
                .then(r => {
                    this.$scope.calculationValue = r;
                });
        }

        public autoCompleteSelected(value) {
            this.$scope.formData[this.$scope.field.schemaProperty.uniqueIdentifier] = value.processId;
            this.$scope.autoCompleteValue = value.output;
            //if (!this.$scope.process.processNames[value.processId]) {
                this.$scope.process.processNames[value.processId] = value.output;
            //}
            //TODO: Jeremy says- do not ask! 
            delete (<any>this.$scope.process.processNames).undefined;
            this.fieldChangedInternal().then(() => {
                //refresh linked grid
                if (this.$scope.field.apiGridConfiguration_id != null) {
                    this.$rootScope.$broadcast("RefreshApiGrid", this.$scope.field.apiGridConfiguration_id);
                }    
            });
        }

        public search(value) {
            return this.autoCompleteService.runAutoComplete(this.$scope.processConfigurationId,
                    this.$scope.field.autoCompleteConfiguration_id,
                    value)
                .then(r => {
                    var mappedReturn = r.data.map(function(item) {
                        return item.output;
                    });

                    //console.log(mappedReturn);
                    //return mappedReturn;
                    return r.data;
                });
        }

        public initiatePayment() {
            if (!this.$scope.processId) {
                alert("Payment would be initiated upon a click of this button");
                return;
            }

            var serviceBase = this.ngAuthSettings.apiServiceBaseUri;
            var paymentConfigId = this.$scope.field.schemaProperty.paymentConfiguration_id;
            var url: string = `${serviceBase}#/InitiatePayment?processId=${this.$scope.processId}&paymentConfigId=${paymentConfigId}`;
            var windowObjectReference = window.open(url, "Payment", "location=0,status=0,width=1366,height=768");

            var pollTimer = window.setInterval(() => {
                    if (windowObjectReference.closed !== false) { // !== is required for compatibility with Opera
                        window.clearInterval(pollTimer);
                        this.paymentWindowClosed(windowObjectReference);
                    }
                },
                200);
        }

        private paymentWindowClosed(windowObjectReference: any):
            void {
            this.processService.getProcessDto(this.$scope.process.id)
                .then(process => {
                    this.$rootScope.$broadcast('ProcessChanged', process);
                });
        }

        public checkAvailability() {
            this.manageScheduledResourceService.checkScheduledResource(
                    this.$scope.processId,
                    this.$scope.formDataId,
                    this.$scope.field.schemaProperty.id,
                    this.$scope.formData[this.$scope.field.schemaProperty.uniqueIdentifier])
                .then(conflictMessage => {
                    if (conflictMessage) {
                        this.growl.error(conflictMessage);
                    } else {
                        this.growl.success("The specified resource is available during the time period specified.");
                    }
                });
        }

        public extfieldChanged = () => this.fieldChanged();

        public zoomToFeature() {
            let value = this.$scope.formData[this.$scope.field.schemaProperty.uniqueIdentifier];
            if (value) {
                this.gisMapService.zoomToFeature(value,this.$scope.process);
            }

        }

        public setListMetadata() {
            if (this.$scope.rowId &&
                this.$scope.process &&
                this.$scope.process.rowMetadata &&
                this.$scope.process.rowMetadata[this.$scope.rowId] &&
                (<any>this.$scope.process.rowMetadata[this.$scope.rowId]).fieldsMetadata[this.$scope.field
                    .schemaProperty.uniqueIdentifier]) {
                const metadataObj =
                    JSON.parse((<any>this.$scope.process.rowMetadata[this.$scope.rowId]).fieldsMetadata[this.$scope
                        .field.schemaProperty.uniqueIdentifier]);

                if (metadataObj.isReadonly) {
                    this.$scope.metaDataReadOnly = true;
                }
            } else {
                this.$scope.metaDataReadOnly = false; 
            } 
        }

        public runGisWorkflow() {
            this.gisMapService.runGisActionWorkflowOverride(this.$scope.field.gisActionWorkflowOverride, this.$scope.process,
                this.$scope.formId,this.$scope.formDataId);
        }

        public fieldChanged() {

            if (!this.$scope.process) {
                return;
            }
            if (this.$scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.Currency) {
                // Doing this because it seems as if the currency input filter is taking a bit to propagate the change.
                setTimeout(() => this.fieldChangedInternal());
            } else if (this.$scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.Number) {
                this.scrubNumericValue();
                this.fieldChangedInternal();
            }
            else {
                this.fieldChangedInternal();
            }
        }

        private scrubNumericValue() {
            var value = this.$scope.formData[this.$scope.field.schemaProperty.uniqueIdentifier];
            var newValue = '';

            var numberBeforeDecimal = false;
            var encounteredDecimalPoint = false;
            var indexAfterDecimal = 0;

            if (value) {
                for (var i = 0, len = value.length; i < len; i++) {
                    var currentChar = value[i];
                    if (currentChar === '.') {
                        if (encounteredDecimalPoint || !numberBeforeDecimal) continue;
                        newValue += currentChar;
                        encounteredDecimalPoint = true;
                    } else if (currentChar >= '0' && currentChar <= '9') {
                        if (!encounteredDecimalPoint) {
                            numberBeforeDecimal = true;
                        }
                        if (encounteredDecimalPoint) {
                            indexAfterDecimal++;
                            if (indexAfterDecimal > this.$scope.field.decimalPlaces) {
                                break;
                            }
                        }

                        newValue += currentChar;
                    }
                }

                if (newValue.substring(newValue.length - 1) === ".") {
                    newValue = newValue.substring(0, newValue.length - 1);
                }
            }

            this.$scope.formData[this.$scope.field.schemaProperty.uniqueIdentifier] = newValue;

            //TODO: validate against max value here too
        }

        public searchUsers(viewValue, userServiceName: string): any {
            if (viewValue.length == undefined || viewValue.length < 3) return null;
            var self = this;
            var searchCriteria = new models.UserSearchCriteria();
            if (userServiceName == null || userServiceName === "") {
                userServiceName = this.$scope.field.userServiceName;
            }
            searchCriteria.userRepository = userServiceName;
            searchCriteria.userName = viewValue;
            return self.userService.searchUsers(searchCriteria);
        }

        public userSelected(item: Wars.Domain.Model.Dtos.UserSearchDto, userServiceName: string) {
            if (this.$scope.formData) {

                this.userService.addExternalUser(item)
                    .then((id) => {
                        this.$scope.formData[this.$scope.field.schemaProperty.uniqueIdentifier] = id;
                        this.fieldChangedInternal();
                    });
            }
        }

        public clearUserPicker() {
            if (this.$scope.formData) {
                this.$scope.formData[this.$scope.field.schemaProperty.uniqueIdentifier] = "";
                (<any>this).selectedUser = null;
                this.fieldChangedInternal();
            }
        }

        public gotoProcess(id: string) {
            this.$location.path('/Process/' + id);
        }

        public getColumnName(column: Wars.Domain.Model.ApiGridColumnConfiguration) {

        }

        public customDivLoaded() {
            this.customDivService.divLoaded(this.$scope.stepId);
        }

        public fieldChangedInternal(): angular.IPromise<any> {
            var q = this.$q.defer();
            
            if (!this.$scope.process || !this.$scope.formData) {
                q.resolve();
                return q.promise;
            }
  
            var formId = this.$scope.parentFormId ? this.$scope.parentFormId : this.$scope.formId;

            let value = this.$scope.formData[this.$scope.field.schemaProperty.uniqueIdentifier];

            if (this.$scope.field != undefined && this.$scope.field.type != undefined)
            {
                if (this.$scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.PhoneNumber ||
                    this.$scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.Zipcode ||
                    (this.$scope.field.type === Wars.Domain.Model.Codes.Enums.FieldType.TextBox &&
                        this.$scope.field.mask != undefined &&
                        this.$scope.field.mask != null &&
                        this.$scope.field.mask !== "")) {
                    if (value !== this.currentValue)
                    {
                        this.currentValue = value;
                    } else {
                        q.resolve();
                        return q.promise;
                    }
                }
            }

            if (value == undefined &&
                this.$scope.field.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Boolean) {
                value = false;
            }

            if (this.$scope.field.disallowEmptyValue && (value === null || value === undefined || value === "")) {
                q.resolve();
                return q.promise;
            }

            if (value &&
            (this.$scope.field.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.DateTime ||
                this.$scope.field.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Date)) {
                value = value.toUTCString();
            }

            if (value && this.$scope.field.schemaProperty.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.ScheduledResource) {
                if (value.beginDate && (typeof value.beginDate !== "string")) {
                    value.beginDate = value.beginDate.toUTCString();
                }
                if (value.endDate && (typeof value.endDate !== "string")) {
                    value.endDate = value.endDate.toUTCString();
                }
            }

            if (this.$scope.formSectionUniqueId) {
                this.formDataService.setListField(this.$scope.processId,
                    formId,
                    this.$scope.formDataId,
                    this.$scope.formSectionUniqueId,
                    this.$scope.rowId,
                    this.$scope.field.schemaProperty.uniqueIdentifier,
                    value).then((result: Wars.Domain.Model.Dtos.FieldUpdateDto) => {
                        this.processService.processFormUpdateResults(
                            this.$scope.process,
                            result.allFieldUpdates,
                            this.conditionService,
                            result.impactedConditionStates);
                        this.runPostSaveEvents();
                    q.resolve();
                });
            } else {
                this.formDataService.setFormField(this.$scope.processId,
                    formId,
                    this.$scope.formDataId,
                    this.$scope.field.schemaProperty.uniqueIdentifier, value).then(
                        (result: Wars.Domain.Model.Dtos.FieldUpdateDto) => {
                            this.processService.processFormUpdateResults(
                                this.$scope.process,
                                result.allFieldUpdates,
                                this.conditionService,
                                result.impactedConditionStates);

                            this.runPostSaveEvents();
                            q.resolve();
                    });
                return q.promise;
            }

        }

        public changeState(): void {
            if (this.selectedState === null || this.selectedState === undefined) {
                this.growl.error("Please select a " + this.$scope.field.schemaProperty.name)
            } else {
                this.processService.changeState(this.$scope.processId, this.selectedState.stateCodeUniqueId)
                    .then((process) => {
                        this.$rootScope.$broadcast('ProcessChanged', process);
                        this.growl.success("Successfully moved to " + (<any>(this.selectedState)).combinedName);
                    });
            }
        }

        private documentUpdated(model: models.FileUploadModel) {
            var id: string = undefined;
            if (model && model.documents && model.documents.length === 1) {
                id = model.documents[0].id;
            }
            this.$scope.formData[this.$scope.field.schemaProperty.uniqueIdentifier] = id;

            this.fieldChanged();
            if (this.$scope.formDataChange) {
                this.$scope.formDataChange();
            }
        }
    }
}

warsApp.registerDirective('Field', []);